import { createContext, ReactNode } from "react";

import { CurrentRef } from "../../../common/hooks/useFormInputRefs";
import { TextFieldProps } from "../TextField";

interface DateTimePickerTextFieldContextProps {
  "data-test": string | undefined;
  error: boolean | undefined;
  errorMessage: string | ReactNode;
  name: string;
  onOpen: () => void;
  onOpenFromInput: (input: HTMLInputElement) => void;
  isOpenedFromInput: boolean;
  refCallback: (currentRef: CurrentRef) => void;
  size: TextFieldProps<never>["size"];
  vibe: TextFieldProps<never>["vibe"];
  endElement?: ReactNode;
  helperText?: string | ReactNode;
}

export const DateTimePickerTextFieldContext = createContext<DateTimePickerTextFieldContextProps>({
  "data-test": "",
  error: false,
  errorMessage: "",
  name: "",
  onOpen: () => {},
  onOpenFromInput: () => {},
  isOpenedFromInput: false,
  refCallback: () => {},
  size: "medium",
  vibe: "neutral",
  endElement: null,
});
